export default "__VITE_ASSET__mshP4cc9__ 1200w";